package pnemonic.balloon_pop.model.prize

enum class Gem {
    // purple
    Amethyst,
    // transparent
    Diamond,
    // green
    Emerald,
    // green
    Jade,
    // red
    Ruby,
    // blue
    Sapphire,
    // orange
    Topaz,
}